import React from 'react';
import { TestResultRp } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { formatDecimal } from '@ecosconnect/core/src/helpers/number';
import PropTypes from 'prop-types';
import {
  rpCheck2Required,
  rpOpenedAtRequired,
  rpPressureDropRequired,
} from '@ecosconnect/core/src/helpers/backflow/helpers';

const RpTestResult: React.FC<{ test: TestResultRp }> = ({ test }) => {
  const dripping = ['upon_arrival', 'upon_closure'].includes(
    test.reliefValveDripping || ''
  );

  return (
    <>
      <AccordionItem
        label="Relief Valve Discharging"
        kind={dripping ? 'chip' : 'text'}
        status={dripping ? 'error' : 'default'}
        value={constantToLabel(dripping ? test.reliefValveDripping : 'no')}
      />
      <AccordionItem
        label="Opened At"
        required={rpOpenedAtRequired(test)}
        kind={test.didNotOpen ? 'chip' : 'text'}
        status={test.didNotOpen ? 'error' : 'default'}
        value={test.didNotOpen ? 'Did not open' : formatDecimal(test.openedAt)}
      />
      <AccordionItem
        label="Pressure Drop"
        required={rpPressureDropRequired(test)}
        value={formatDecimal(test.pressureDrop)}
      />
      <AccordionItem
        label="Check 2"
        status={test.check2 === 'leaked' ? 'error' : undefined}
        kind={test.check2 === 'leaked' ? 'chip' : 'text'}
        required={rpCheck2Required(test)}
        value={
          test.check2 === 'other'
            ? formatDecimal(test.check2Other)
            : constantToLabel(test.check2)
        }
      />
    </>
  );
};

RpTestResult.propTypes = {
  test: PropTypes.any.isRequired,
};

export default RpTestResult;
